import React from "react";
import useMediaTerms from "app/app/mediaSelector/hooks/use-media-terms";
import MediaFilterContext from "app/app/mediaSelector/contexts/MediaFilterContext"
import useMediaContext from "app/app/mediaSelector/hooks/use-media-context";

function MediaFilterProvider(props) {
    const items = useMediaContext();
    const {availableCountryTerms, availableAreaTerms, availableTagTerms} = useMediaTerms();

    const [filter, setFilter] = React.useState({
        country: 0,
        area: 0,
        tag: 0
    })

    const handleCountryChange = (e) => {
        const updated = Object.assign({}, {country: Number(e.target.value), area: 0, tag: 0})
        setFilter(updated)
    }

    const handleAreaChange = (e) => {
        const updated = Object.assign({}, {country: 0, area: Number(e.target.value), tag: 0})
        setFilter(updated)
    }

    const handleTagChange = (e) => {
        const updated = Object.assign({}, {country: 0, area: 0, tag: Number(e.target.value)})
        setFilter(updated)
    }

    const filteredItems = (items) => {
        if (filter.area) {
            return items.filter(item => item.areaTerms && item.areaTerms.some(area => area.term_id === filter.area))
        }

        if (filter.country) {
            return items.filter(item => item.countryTerms && item.countryTerms.some(country => country.term_id === filter.country))
        }

        if (filter.tag) {
            return items.filter(item => item.tagTerms && item.tagTerms.some(tag => tag.term_id === filter.tag))
        }

        return items
    }


    let value = {
        filteredItems: filteredItems(items),
        availableCountryTerms,
        availableAreaTerms,
        availableTagTerms,
        selectedCountry: filter.country,
        selectedArea: filter.area,
        selectedTag: filter.tag,
        handleCountryChange,
        handleAreaChange,
        handleTagChange
    }

    return (
        <MediaFilterContext.Provider value={value}>
            {props.children}
        </MediaFilterContext.Provider>
    );
}

export default MediaFilterProvider;
